export default __webpack_public_path__ + "static/media/times_square.ae4a19e3.jpeg";